import { FC, ReactElement, ReactNode } from 'react';
import { ActionGroup } from 'src/components/buttons-and-actions/action-group';
import { Size } from 'src/components/buttons-and-actions/button';
import { IconDropdown } from 'src/components/buttons-and-actions/icon-dropdown';
import { flattenChildren } from 'src/utils/flatten-children';

type SplitActionsProps = {
  children: ReactNode;
  initialActive?: boolean;
  empty?: ReactElement;
  testId?: string;
  mode?: 'button-primary' | 'button-secondary';
  size?: Size;
};

export const SplitActions: FC<SplitActionsProps> = ({
  children,
  initialActive = false,
  empty = null,
  testId,
  mode,
  size,
}) => {
  const actions = flattenChildren(children);
  if (!actions.length) return empty;

  const [firstAction, ...remainingActions] = actions;

  return (
    <ActionGroup mode={mode} size={size}>
      {firstAction}

      {remainingActions.length ? (
        <IconDropdown
          label="Show or Hide Additional Actions"
          data-testid={
            testId !== undefined ? `split-actions-toggle-${testId}` : undefined
          }
          initialActive={initialActive}
        >
          {remainingActions}
        </IconDropdown>
      ) : null}
    </ActionGroup>
  );
};
